import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { BreadcrumbBackButton } from './ReportLibraryBreadcrumb.styles';

interface ReportLibraryBreadcrumbProps {
  title: string;
  onBack: () => void;
}

export const ReportLibraryBreadcrumb = ({
  title,
  onBack,
}: ReportLibraryBreadcrumbProps) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={0.75}
    flexWrap="wrap"
    marginBottom={3}
  >
    <BreadcrumbBackButton
      type="button"
      variant="text"
      onClick={onBack}
      aria-label="Back to Report Library"
      sx={{ typography: 'h4', fontWeight: 700, color: 'text.disabled' }}
    >
      Report Library
    </BreadcrumbBackButton>
    <Text variant="h4" fontWeight={700} color="text.disabled" component="span">
      /
    </Text>
    <Text variant="h4" fontWeight={700} component="span">
      {title}
    </Text>
  </Stack>
);
